import script from "./VLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./VLoader.vue?vue&type=script&setup=true&lang=js"

import "./VLoader.vue?vue&type=style&index=0&id=817f1696&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-817f1696"]])

export default __exports__